import styled from '@emotion/styled'
import TextField from '@mui/material/TextField'

const ChipsInputContainer = styled(TextField)`
	min-width: 500px;
	width: 500px;
	display: flex;
	flex-wrap: wrap;
	& .MuiOutlinedInput-root {
		display: flex;
		flex-wrap: wrap;

		input {
			flex: 1;
		}
	}
`

export { ChipsInputContainer }
